import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Alert } from "react-bootstrap";
import { Button } from "react-bootstrap";
import GoogleButton from "react-google-button";
import { useUserAuth } from "./UserAuthContext";

const Login = () => {

  const [error, setError] = useState("");
  const { googleSignIn } = useUserAuth();
  const navigate = useNavigate();


  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    try {
      await googleSignIn();
      navigate("/Homelogged");
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <div className="container p-4 mt-5" style={{alignItems:'center',justifyContent:'center',width:"30vw"}}>
        <h2 className="mb-3 text-center">Login</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        
        <div className="d-flex text-align-center align-items-center justify-content-center flex-column">
        <img src="https://play-lh.googleusercontent.com/k2j3ll7b4e47GlCNSi8He30DjnKiCB3PCXn6Nc4nH8LZYcND2eTu4VQm6HRRPst_cQ8=w240-h480-rw" alt="" className="img-fluid" />
          <GoogleButton
            className="g-btn text-center mt-4"
            type="dark"
            onClick={handleGoogleSignIn}
          />
        </div>
      </div>
      {/* <div className="p-4 box mt-3 text-center">
        Don't have an account? <Link to="/signup">Sign up</Link>
      </div> */}
    </>
  );
};

export default Login;